(function ($) {
  /*
  * スクロールアニメーション
  */
  const delta = $(window).height() / 1.6;
  function scrollEffect() {
    $('.js-effect').each(function (i) {
      const elemPosition = $(this).offset().top;
      const scrollTop = $(window).scrollTop();
      if (scrollTop > elemPosition - delta) {
        $(this).addClass('is-visible');
      } else {
        $(this).removeClass('is-visible');
      }
    });
  }

  /**
   * scroll
   */
  $(window).scroll(() => {
    scrollEffect();
  });


  /**
   * load
   */
  $(window).on('load', () => {
    scrollEffect();
  });
})(window.jQuery);
